import React from 'react'
import CommonFooter from '../../components/CommonFooter/CommonFooter'
import CommonNavbar from '../../components/CommonNavbar/CommonNavbar'

const RentTractor = () => {
  return (
    <>
      <CommonNavbar />
      <div className='py-5'>
        <div className='container px-md-5'>
          <div className='p-8 bg-white'>
            <div className='max-w-5xl mx-auto'>
              {/* Header */}
              <h2 className='text-3xl font-bold text-gray-800 mb-4 clr_dark_green'>
                Explore a Range of Agricultural Machinery for Rent
              </h2>
              <p className='text-gray-600 mb-8'>
                Farmer’s City offers farmers the opportunity to rent a variety
                of agricultural machinery and equipment to enhance their farming
                operations. Our platform serves as a convenient solution for
                farmers looking to access high-quality machinery on a custom
                hiring basis, providing flexibility and cost-effective options
                to meet their specific needs.
              </p>

              {/* Services Offered */}
              <h3 className='text-2xl font-semibold text-gray-800 mb-4 clr_dark_green'>
                Services Offered for Renting Agri Machinery
              </h3>
              <ul className='list-disc pl-6 text-gray-700 mb-8 space-y-2'>
                <li>
                  <strong>Custom Hiring Services:</strong> Partnering with
                  Rental as a Service (RaaS) platforms, we enable farmers to
                  rent or book agricultural machinery such as tractors,
                  harvesters, plows, and more based on their requirements.
                </li>
                <li>
                  <strong>Machinery Rental Marketplace:</strong> Browse through
                  our online marketplace to discover a wide selection of
                  agricultural machinery available for rent, with transparent
                  pricing and rental terms.
                </li>
                <li>
                  <strong>Flexible Rental Options:</strong> Choose from hourly,
                  daily, or seasonal rental options to suit your farming
                  schedule and budget, ensuring maximum efficiency and
                  productivity on the farm.
                </li>
                <li>
                  <strong>Quality Assurance:</strong> Rest assured that all
                  rented machinery undergoes regular maintenance and quality
                  checks to ensure optimal performance and reliability during
                  use.
                </li>
              </ul>

              {/* How to Rent */}
              <h3 className='text-2xl font-semibold text-gray-800 mb-4 clr_dark_green'>
                How to Rent Agri Machinery at Farmer’s City
              </h3>
              <ul className='list-disc pl-6 text-gray-700 mb-8 space-y-2'>
                <li>
                  <strong>Browse Online Marketplace:</strong> Visit our
                  e-commerce platform to explore the range of agricultural
                  machinery available for rent, complete with detailed
                  descriptions and pricing information.
                </li>
                <li>
                  <strong>Select Desired Equipment:</strong> Choose the specific
                  machinery you need for your farming activities, considering
                  factors such as horsepower, capacity, and features that align
                  with your operational requirements.
                </li>
                <li>
                  <strong>Book Rental Services:</strong> Reserve the selected
                  equipment by specifying the rental duration and
                  pickup/delivery preferences, ensuring a seamless booking
                  process for your convenience.
                </li>
                <li>
                  <strong>Enjoy Hassle-Free Rental:</strong> Experience
                  hassle-free rental services with transparent pricing, reliable
                  machinery, and dedicated support to address any queries or
                  concerns during the rental period.
                </li>
              </ul>

              {/* Franchise Opportunities */}
              <h3 className='text-2xl font-semibold text-gray-800 mb-4 clr_dark_green'>
                Franchise Opportunities for Agri Machinery Dealers
              </h3>
              <p className='text-gray-600 mb-6'>
                If you are a machinery dealer interested in expanding your reach
                and connecting with a broader customer base, consider partnering
                with Farmer’s City as an agri equipment supplier. By joining our
                platform, you can benefit from:
              </p>
              <ul className='list-disc pl-6 text-gray-700 mb-8 space-y-2'>
                <li>
                  Increased visibility and access to farmers seeking
                  agricultural machinery for rent.
                </li>
                <li>
                  Commission-based rental opportunities that help you reach new
                  customers and grow your business.
                </li>
                <li>
                  Seamless integration with our e-commerce platform for
                  efficient transactions and order management.
                </li>
              </ul>

              {/* Closing */}
              <p className='text-gray-700 font-medium'>
                Join us in revolutionizing the way farmers access and rent
                agricultural machinery, making farming operations more efficient
                and productive.
              </p>
            </div>
          </div>
        </div>
      </div>
      <CommonFooter />
    </>
  )
}

export default RentTractor
